import React from 'react';
import { NavLink } from "react-router-dom";

import MenuBar from './../components/Menubar';

type Props = { 
	user: any
};

const AboutPage: React.FC<Props> = (props) => {
	return (
		<main className="main-bg  about-page">
			<div className="container">
				<MenuBar user={props.user}/>
				<section>
					<div
						className="about-content terms-content policy-content"
						style={{marginTop:'70px', marginLeft: '50px'}}
					>
						<div className="terms-box bg-white"> 
							<p className="mt-4 pb-4 f-20 avenir">
								We are a community of food lovers sharing and upvoting the best menu discoveries.
							</p>
							<div className="page-link avenir f-20"><NavLink to="/terms">Terms of use</NavLink></div>
							<div className="page-link avenir f-20"><NavLink to="/policy">Privacy policy</NavLink></div>
							<div className="page-link avenir f-20"><a href="mailto:info@yolomeal.com">Contact Us</a></div>
						</div>
					</div>
				</section> 
			</div>
		</main>
	);
}

export default AboutPage;
